import { createBrowserRouter, Navigate } from 'react-router-dom';
import { publicRoutes } from '@/app/router/routes/publicRoutes';
import { guestAuthRoutes } from '@/app/router/routes/guestAuthRoutes';
import { appShellRoutes } from '@/app/router/routes/appShellRoutes';
import { routes } from '@/shared/config/routes';

export const appRouter = createBrowserRouter([
  ...publicRoutes,
  ...guestAuthRoutes,
  ...appShellRoutes,
  { path: '*', element: <Navigate to={routes.home} replace /> },
]);
